import { predicateFor } from '@gonfalon/legacy-form-validation/validationUtils';

import type { Member } from '#utils/members/records/Member';
import type { Team } from '#utils/teams/records/Team';

import { validateNotifyReviewersCount } from './validateNotifyReviewersCount';

export const isValidNotifyReviewersCount = (maxLength: number, teams: Team[], members: Member[]) =>
  predicateFor(
    () => validateNotifyReviewersCount(maxLength, teams, members),
    () => `You may only specify at most ${maxLength} reviewers`,
  );
